const STORAGE_KEY = 'post_login_redirect';

/**
 * Google redirect sign-in leaves the SPA, so `location.state.from` is lost.
 * The login page parks the intended destination here and, once authenticated,
 * reads it back. Storage can be unavailable (private mode), so every access
 * is best-effort.
 */
export function savePostLoginRedirect(from: string | undefined): void {
  try {
    if (from) sessionStorage.setItem(STORAGE_KEY, from);
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Falling back to the default landing page is acceptable.
  }
}

/** Returns the saved in-app path, or null if absent or not a safe relative path. */
export function readPostLoginRedirect(): string | null {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    return value && value.startsWith('/') && !value.startsWith('//')
      ? value
      : null;
  } catch {
    return null;
  }
}

export function clearPostLoginRedirect(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clean up.
  }
}
